import React, { useState } from 'react';
import { LeaderboardPeriod } from './LeaderboardTypes';
import LeaderboardTabs from './LeaderboardTabs';
import LeaderboardList from './LeaderboardList';
import useLeaderboardData from './useLeaderboardData';
import { LeaderboardContainer, LeaderboardHeader } from './LeaderboardStyles';

const Leaderboard: React.FC = () => {
  const [activeTab, setActiveTab] = useState<LeaderboardPeriod>('last-month');
  const { leaderboardData, isLoading, error } = useLeaderboardData(activeTab);

  const handleTabChange = (tab: LeaderboardPeriod) => {
    setActiveTab(tab);
  };

  return (
    <LeaderboardContainer>
      <LeaderboardHeader>
        <h1>Leaderboard</h1>
        <p>Top users based on upvotes and engagement</p>
      </LeaderboardHeader>

      <LeaderboardTabs
        activeTab={activeTab}
        onTabChange={handleTabChange}
      />

      <LeaderboardList
        entries={leaderboardData}
        isLoading={isLoading}
        error={error}
      />
    </LeaderboardContainer>
  );
};

export default Leaderboard;
